import { render, staticRenderFns } from "./fccMensagens.vue?vue&type=template&id=149b4585"
import script from "./fccMensagens.vue?vue&type=script&lang=js"
export * from "./fccMensagens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports